/**
 * 전역 fetch 인터셉터
 * 모든 fetch 요청을 가로채서 401 에러 시 자동 로그아웃 처리
 */

// 401 오류 시 자동 로그아웃 처리 함수
const handle401Error = () => {
  console.error('🚨 401 인증 오류 감지 - 세션 만료로 자동 로그아웃 처리');

  // 1. localStorage에서 JWT 토큰 제거
  localStorage.removeItem('adminToken');

  // 2. Zustand persist 스토리지 제거 (로그인 상태 초기화)
  localStorage.removeItem('bus-auth-storage');

  // 3. 세션 만료 플래그 설정 (로그인 페이지에서 메시지 표시용)
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.setItem('session_expired', 'true');
  }

  // 4. 사용자에게 알림
  if (typeof window !== 'undefined') {
    console.warn('⚠️ 세션이 만료되었습니다. 다시 로그인해주세요.');

    // 5. 페이지 새로고침 (LoginApp에서 isAuthenticated가 false가 되어 로그인 페이지로 이동)
    // 단, 이미 로그아웃 처리 중이면 무한 루프 방지
    if (!sessionStorage.getItem('logout_in_progress')) {
      sessionStorage.setItem('logout_in_progress', 'true');
      setTimeout(() => {
        sessionStorage.removeItem('logout_in_progress');
        window.location.reload();
      }, 100);
    }
  }
};

/**
 * 전역 fetch 인터셉터 설정
 * 앱 시작 시 한 번만 호출
 */
export const setupFetchInterceptor = () => {
  // 원본 fetch 저장
  const originalFetch = window.fetch;

  // fetch 오버라이드
  window.fetch = async (...args: Parameters<typeof fetch>): Promise<Response> => {
    const [resource, config] = args;

    try {
      // 원본 fetch 호출
      const response = await originalFetch(resource, config);

      // 401 에러 체크
      if (response.status === 401) {
        // URL 로깅 (디버깅용)
        const url = typeof resource === 'string'
          ? resource
          : (resource instanceof Request ? resource.url : resource.toString());
        console.error(`🚨 401 Unauthorized: ${url}`);

        // 자동 로그아웃 처리
        handle401Error();

        // 에러 응답 반환 (클라이언트 코드에서 처리할 수 있도록)
        return response;
      }

      return response;
    } catch (error) {
      // 네트워크 에러 등은 그대로 throw
      throw error;
    }
  };

  console.log('✅ 전역 fetch 인터셉터 설정 완료 - 401 에러 시 자동 로그아웃');
};

export default setupFetchInterceptor;
